<template>
    <a-card class="freeEvaluation">
        <a-form-model layout="inline">
            <a-form-model-item label="项目名称">
                <a-input placeholder="请输入" allow-clear :maxLength="20" v-model="searchForm.name" style="width:220px;"/>
            </a-form-model-item>
            <a-form-model-item label="项目状态">
                <a-select class="serach-item" allowClear v-model="searchForm.enabled" @keyup.enter="getList(1)"
                          placeholder="请选择">
                    <a-select-option value="true">开启</a-select-option>
                    <a-select-option value="false">关闭</a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item>
                <a-button type="primary" @click="getList(1)">查询</a-button>
                <a-button style="margin: 0 35px 0 15px;" @click="resetSearch()">重置</a-button>
            </a-form-model-item>
            <a-form-model-item style="float: right;">
                <a-button type="primary" @click="addProject()" v-permission="`/operate/FreeEvaluation/ProjectSeting`">添加项目
                </a-button>
            </a-form-model-item>
        </a-form-model>
        <div class="table">
            <a-table style="min-width: 800px;"
                     :columns="columns"
                     row-key="id"
                     :pagination="tableRelevant.tablePagination"
                     :loading="tableRelevant.tableLoading"
                     :locale="tableRelevant.locale"
                     :dataSource="tableRelevant.tableDataSource">
                <div slot="status" slot-scope="text, record" class="_flex" v-auth="`Operate.FreeEvaluation.Update`">
                    <a-switch checked-children="开启" un-checked-children="关闭" :checked="text.enabled"
                              @click="statusChange(text)"/>
                </div>
                <div slot="action" slot-scope="text, record" class="action">
                    <a @click="edit(text)" v-permission="`/operate/FreeEvaluation/ProjectSeting`">编辑</a>
                    <a @click="$router.push(`/operate/FreeEvaluation/FreeEvaluationDetail?id=${text.id}&name=${text.name}`)"
                       v-permission="`Operate.FreeEvaluation.Detail`">项目详情</a>
                    <a-dropdown>
                        <a class="ant-dropdown-link">更多
                            <a-icon type="down"/>
                        </a>
                        <a-menu slot="overlay">
                            <a-menu-item v-permission="`Operate.FreeEvaluation.Channel`">
                                <a @click="$router.push(`/operate/ChannelDispose/FreeEvaluationChannel?id=${text.id}&name=${text.name}`)"
                                   href="javascript:;">渠道链接</a>
                            </a-menu-item>
                            <a-menu-item v-permission="`Operate.FreeEvaluation.Delete`">
                                <a class="red" @click="deleteProject(record)">
                                    删除
                                </a>
                            </a-menu-item>
                        </a-menu>
                    </a-dropdown>
                </div>
            </a-table>
        </div>
    </a-card>
</template>

<script>
    import $Bus from "@/pages/projectImpl/js/eventBus"
    import {tableRelevant} from "@/pages/projectImpl/js/utils";

    const columns = [
        {title: '项目名称', key: "1", dataIndex: 'name'},
        {title: '状态', key: "6", scopedSlots: {customRender: 'status'}},
        {title: '操作', width: 250, key: "7", scopedSlots: {customRender: 'action'}}
    ]

    export default {
        name: 'freeEvaluation',
        data() {
            return {
                searchForm: {
                    name: '',
                    enabled: undefined
                },
                statusArr: ['开启', '关闭'],
                columns,
                tableRelevant: tableRelevant.call(this, this.getList),
            }
        },
        created() {

        },
        mounted() {
            $Bus.$emit("pageHeaderTitle", "测评配置");
            this.getList(1)
        },
        methods: {
            getList(pageIndex) {
                let params = {
                    ...this.searchForm,
                    promotionGroupType: 1,
                    pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
                    pageSize: this.tableRelevant.tablePagination.pageSize,
                }
                this.tableRelevant.tableLoading = true
                this.$http.operate.GetGroupPageList(params)
                    .then(res => {
                        this.tableRelevant.tableLoading = false
                        this.tableRelevant.tableDataSource = res.data.items
                        this.tableRelevant.tablePagination.total = res.data.totalCount;
                        this.tableRelevant.tablePagination.current = res.data.pageIndex;
                    })
                    .catch(err => {
                        this.tableRelevant.tableLoading = false
                    })
            },
            addProject() {
                localStorage.setItem('detailId', '');
                this.$router.push({
                    path: '/operate/FreeEvaluation/ProjectSeting',
                    query: {
                        type: 'add'
                    }
                })
            },
            edit(text) {
                this.$router.push({
                    path: '/operate/FreeEvaluation/ProjectSeting',
                    query: {
                        type: 'edit',
                        id: text.id
                    }
                })
            },
            deleteProject(text) {
                this.$confirm({
                    title: '确认删除此项目',
                    centered: true,
                    okType: 'danger',
                    onOk: () => {
                        this.tableRelevant.tableLoading = true
                        let formData = new FormData();
                        formData.append('id', text.id);
                        this.$http.operate.DeleteGroup(formData)
                            .then(res => {
                                this.tableRelevant.tableLoading = false
                                this.$message.success('删除成功')
                                this.getList(1)
                            })
                            .catch(err => {
                                this.tableRelevant.tableLoading = false
                            })
                    }
                });
            },
            statusChange(text) {
                this.tableRelevant.tableLoading = true
                this.$message.destroy();
                let formData = new FormData();
                formData.append('id', text.id)
                this.$http.operate.UpdateStatus(formData)
                    .then(res => {
                        this.tableRelevant.tableLoading = false
                        this.$message.success(res.data)
                        text.enabled = !text.enabled
                    })
                    .catch(err => {
                        this.tableRelevant.tableLoading = false
                    })
            },
            resetSearch() {
                this.searchForm = {
                    name: '',
                    enabled: undefined
                }
                this.getList(1)
            },
        }
    }
</script>

<style scoped>

</style>
